/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import errorMsg from "../json/errMsg.json";
//import validator from 'validator';

import { username, isEmpty, isLength, checkURL, isNumber } from "./common.js";
import {
  DEFAULT_LANGUAGE,
  MIN_STATEMENT_DESCRIPTOR_LENGTH,
  MAX_STATEMENT_DESCRIPTOR_LENGTH,
  DEFAULT_PAYMENT_MINIMUM_LIMIT,
} from "../../config";

export const validOrgInfo = {
  username: (err) => {
    return {
      ...username(err),
      ...{
        msgOnError:
          err === "" ? errorMsg[DEFAULT_LANGUAGE].orgInfoErr.username : err,
      },
    };
  },
  checkSD: (inputtxt) => {
    if (isEmpty(inputtxt)) return false;
    const letters = /^[0-9a-zA-Z ]+$/;
    if (!inputtxt.match(letters)) return false;
    return isLength(
      inputtxt,
      MAX_STATEMENT_DESCRIPTOR_LENGTH,
      MIN_STATEMENT_DESCRIPTOR_LENGTH,
    );
  },
  validUrl: (url) => {
    return checkURL(url);
  },
  validMinAmount: (amount) => {
    if (isEmpty(amount.toString())) return true;
    return isNumber(amount, DEFAULT_PAYMENT_MINIMUM_LIMIT);
  },
};
